"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const resolveZodIssuePath = (issuePath) => {
    let fullPath = "";
    issuePath.forEach((path, index) => {
        fullPath = fullPath + `${index !== 0 ? "." : ""}${path}`;
    });
    return fullPath;
};
exports.default = resolveZodIssuePath;
